import { User } from "../user/user";

export class Customer extends User {
    public userId: string;
    public externalId: string;
    public rewardCount: number;
    public unitCount: number;
    public statusId: boolean = false;
    public gender: string;
    public address1: string;
    public address2: string;
    public city: string;
    public provinceID: number;
    public suburb: string;
    public postalCode: string;
    public country: string;
    public dateOfBirth: Date;
    public anniversary: Date;
    public enrollmentDate: Date;
    public receiveEmail: boolean;
    public receiveSms: boolean;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/customer/customer.ts